/* ZOALIN_MOBILE_SEARCH_CLEAN_V2_20260719 */
(function () {
  var mediaQuery = window.matchMedia('(max-width: 749px)');
  var styleId = 'zoalin-mobile-search-clean-v2-20260719-style';

  function shouldRun() {
    return mediaQuery.matches;
  }

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '@media(max-width:749px){',
      '.search-modal__content .zoalin-search-modal-logo{display:flex!important;width:max-content!important;max-width:max-content!important;min-width:0!important;min-height:30px!important;margin:26px auto 18px!important;padding:0!important;border:0!important;outline:none!important;outline-width:0!important;outline-color:transparent!important;box-shadow:none!important;align-items:center!important;justify-content:center!important;color:#111!important;font-family:Georgia,"Times New Roman",serif!important;font-size:1.5rem!important;font-weight:400!important;letter-spacing:.09em!important;line-height:1!important;text-decoration:none!important;}',
      '.search-modal__content .zoalin-search-modal-logo:focus,.search-modal__content .zoalin-search-modal-logo:focus-visible{outline:none!important;outline-width:0!important;box-shadow:none!important;}',
      '.search-modal__content .zoalin-search-modal-logo:before{content:"ZOALIN"!important;display:block!important;}',
      '.search-modal__content .zoalin-search-modal-logo img{display:none!important;}',
      '.search-modal__content .predictive-search-form__content-wrapper,.search-modal__content .zoalin-search-layout-20260707{display:block!important;width:calc(100vw - 36px)!important;max-width:900px!important;margin:16px auto 54px!important;padding:0!important;border:0!important;background:transparent!important;overflow:visible!important;}',
      '.search-modal__content .zoalin-search-quicklinks{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;visibility:hidden!important;}',
      '.search-modal__content .zoalin-search-products-20260712{margin:0!important;padding:0!important;border-top:0!important;}',
      '.search-modal__content .zoalin-search-products-20260712__header{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;visibility:hidden!important;}',
      '.search-modal__content .zoalin-search-products-20260712__grid{display:grid!important;grid-auto-flow:row!important;grid-auto-columns:unset!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:18px 12px!important;width:100%!important;margin:0!important;padding:0!important;overflow:visible!important;scroll-snap-type:none!important;}',
      '.search-modal__content .zoalin-search-product-card-20260712__details{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;gap:8px!important;align-items:start!important;padding-top:9px!important;}',
      '}',
      '@media(max-width:390px){.search-modal__content .predictive-search-form__content-wrapper,.search-modal__content .zoalin-search-layout-20260707{margin-top:14px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function applyCleanSearch() {
    if (!shouldRun()) return;
    ensureStyle();

    document.querySelectorAll('.search-modal__content .zoalin-search-modal-logo').forEach(function (logo) {
      logo.style.setProperty('display', 'flex', 'important');
      logo.style.setProperty('width', 'max-content', 'important');
      logo.style.setProperty('max-width', 'max-content', 'important');
      logo.style.setProperty('min-width', '0', 'important');
      logo.style.setProperty('margin', '26px auto 18px', 'important');
      logo.style.setProperty('padding', '0', 'important');
      logo.style.setProperty('border', '0', 'important');
      logo.style.setProperty('outline', 'none', 'important');
      logo.style.setProperty('outline-width', '0', 'important');
      logo.style.setProperty('outline-color', 'transparent', 'important');
      logo.style.setProperty('box-shadow', 'none', 'important');
      logo.style.setProperty('font-family', 'Georgia, "Times New Roman", serif', 'important');
      logo.style.setProperty('font-size', '1.5rem', 'important');
      logo.style.setProperty('letter-spacing', '.09em', 'important');
      logo.querySelectorAll('img').forEach(function (img) {
        img.style.setProperty('display', 'none', 'important');
      });
    });

    document.querySelectorAll('.search-modal__content .zoalin-search-quicklinks').forEach(function (node) {
      node.hidden = true;
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('height', '0', 'important');
      node.style.setProperty('margin', '0', 'important');
      node.style.setProperty('padding', '0', 'important');
    });

    document.querySelectorAll('.search-modal__content .zoalin-search-products-20260712__header').forEach(function (node) {
      node.hidden = true;
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('height', '0', 'important');
      node.style.setProperty('margin', '0', 'important');
      node.style.setProperty('padding', '0', 'important');
    });
  }

  function start() {
    [0, 60, 180, 420, 900, 1600, 2600].forEach(function (delay) {
      window.setTimeout(applyCleanSearch, delay);
    });

    var observer = new MutationObserver(applyCleanSearch);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', applyCleanSearch);
  mediaQuery.addEventListener('change', applyCleanSearch);
})();
